/**
 * Canonical VeilStream site footer links — keep identical across
 * console, pricing, support, docs, and other public frontends.
 */

export interface SiteFooterNavLink {
  label: string
  href: string
  /** Open in a new tab (e.g. Pricing from the console app shell) */
  openInNewTab?: boolean
}

export interface SiteFooterSocialLink {
  label: string
  href: string
  network: 'github' | 'linkedin' | 'twitter' | 'email'
}

/** Absolute URLs for marketing / docs / support sites. */
export const SITE_FOOTER_NAV_LINKS: SiteFooterNavLink[] = [
  { label: 'Terms of Service', href: 'https://app.veilstream.com/tos' },
  { label: 'Privacy Policy', href: 'https://app.veilstream.com/privacy' },
  { label: 'Refund Policy', href: 'https://app.veilstream.com/tos#refund' },
  { label: 'Pricing', href: 'https://pricing.veilstream.com' },
]

/**
 * Console-relative legal links (same pages, hosted on the app origin).
 * Pricing stays absolute.
 */
export const SITE_FOOTER_NAV_LINKS_APP: SiteFooterNavLink[] = [
  { label: 'Terms of Service', href: '/tos' },
  { label: 'Privacy Policy', href: '/privacy' },
  { label: 'Refund Policy', href: '/tos#refund' },
  { label: 'Pricing', href: 'https://pricing.veilstream.com', openInNewTab: true },
]

export const SITE_FOOTER_SOCIAL_LINKS: SiteFooterSocialLink[] = [
  { label: 'GitHub', href: 'https://github.com/veilstream', network: 'github' },
  { label: 'LinkedIn', href: 'https://linkedin.com/company/veilstream', network: 'linkedin' },
  { label: 'Twitter', href: 'https://twitter.com/veilstream', network: 'twitter' },
  { label: 'Email', href: 'mailto:contact@veilstream.com', network: 'email' },
]

export function siteFooterCopyright(year: number = new Date().getFullYear()): string {
  return `© ${year} VeilStream. All rights reserved.`
}
